import apiClientCreator from "@/helpers/api/request";

export default {
  methods: {
    setQuestionsData() {
      // if (
      //     this.getChartsViewBlocks[1] !== "questions"
      // ) {
      //     return;
      // }
      let rootPath = "";
      let q_list = this.getQuestionsList();
      q_list = q_list.filter(item => {
        return item !== this.questionId;
      });

      let count = 2;
      q_list.map(async q => {
        if (q === "status") {
          rootPath = `client/stats/multiselect/${this.sector}/questions_status`;
        } else {
          rootPath = `client/stats/multiselect/${this.sector}/${q}`;
        }

        await apiClientCreator(rootPath)
          .get("", { params: this.tempParams })
          .then(res => {
            let hash = Math.floor(Math.random() * 10000) + 1;
            if (this.multiSelectChartData.selectedSector === this.sector) {
              let chartData = {
                mainSector: this.sector,
                selectedTab: "questions",
                valid: true,
                data: res.data,
                fromChart: false,
                tabsList: [],
                hash: hash,
                questions: count,
                qLabel:
                  q === "status" ? "question status" : this.setPlaceHolder(q)
              };
              this.$store.commit("clients/setMultiSelectChartData", [
                chartData,
                this.sector
              ]);
            }
          })
          .catch(err => {});
        count++;
      });
    },

    getQuestionsList() {
      let list = [];
      if (this.questionSector === 1) {
        list = [11, 1, 9, 2];
      }
      if (this.questionSector === 2) {
        list = [3, 4, 5, 6];
      }
      if (this.questionSector === 3) {
        list = [7, 8, 10, "status"];
      }
      return list;
    }
  }
};
